import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6cd0e458"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("My account");

var _hoisted_3 = {
  class: "mt-2"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" If you didn't receive the email, you can ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("click here");

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" to get a new one. ");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" A validation email has been sent to you in the last 5 minutes, you will be able to request a new one in ");

var _hoisted_8 = /*#__PURE__*/_createTextVNode(". ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("Update my information");

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" Username · ");

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("small", null, "(Cannot be updated)", -1);
});

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" New password · ");

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("small", null, "(Only if you want to change it)", -1);
});

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" Update ");

import { h, reactive, computed, ref, watch } from "vue";
import { useDialog, useMessage } from "naive-ui";
import { DateTime } from "luxon";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { UserModel, UserValidator } from "@/schemes/user";
import { handleError } from "@/utils/errors";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var userStore = useUserStore();
    var messageAPI = useMessage();
    var dialogAPI = useDialog();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      update: LoaderStateEnum.Idle,
      validation: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var model = reactive(_objectSpread({}, UserModel));
    var rules = {
      email: UserValidator.email.filter(function (r) {
        return !r.required;
      }),
      password: UserValidator.password.filter(function (r) {
        return !r.required;
      })
    };
    var form = ref(null);
    var validationLock = reactive({
      duration: 0,
      threshold: 5
    });

    var resetModel = function resetModel() {
      if (!userStore.user) return;
      model.username = userStore.user.userName;
      model.email = userStore.user.email;
      model.password = "";
    };

    var setValidationLockDuration = function setValidationLockDuration() {
      var _userStore$user;

      if (!((_userStore$user = userStore.user) !== null && _userStore$user !== void 0 && _userStore$user.validationIntentDate)) return;
      var date = DateTime.fromISO(userStore.user.validationIntentDate, {
        zone: "UTC"
      });
      var threshold = date.plus({
        minutes: validationLock.threshold
      });
      validationLock.duration = threshold.diffNow().milliseconds;
    };

    resetModel();

    var renderCountdown = function renderCountdown(_ref) {
      var hours = _ref.hours,
          minutes = _ref.minutes,
          seconds = _ref.seconds;
      var rendered = {
        hours: hours > 0 ? "".concat(String(hours).padStart(2, "0"), ":") : "",
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0")
      };
      return [h("span", {}, ["".concat(rendered.hours).concat(rendered.minutes, ":").concat(rendered.seconds)])];
    };

    var changed = computed(function () {
      var _userStore$user2;

      return model.email.trim() !== ((_userStore$user2 = userStore.user) === null || _userStore$user2 === void 0 ? void 0 : _userStore$user2.email) || model.password.length > 0;
    });
    var validationLocked = computed(function () {
      return validationLock.duration > 0;
    });
    watch(function () {
      var _userStore$user3;

      return (_userStore$user3 = userStore.user) === null || _userStore$user3 === void 0 ? void 0 : _userStore$user3.validationIntentDate;
    }, function () {
      return setValidationLockDuration();
    }, {
      immediate: true
    });

    var update = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var user, payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!form.value || !changed.value)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return form.value.validate();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", false);

              case 10:
                loaders.update = LoaderStateEnum.Loading;
                _context.prev = 11;
                user = userStore.user;
                payload = {};

                if (model.email.trim() !== user.email) {
                  payload.email = model.email;
                }

                if (model.password.length > 0) {
                  payload.password = model.password;
                }

                _context.next = 18;
                return userStore.update(payload);

              case 18:
                resetModel();
                loaders.update = LoaderStateEnum.Loaded;

                if (payload.email) {
                  dialogAPI.info({
                    title: "Email changed",
                    content: "\nYour account has been successfully updated.\n\nAs you changed your email, you will soon receive a validation link on the new one, please check it!",
                    positiveText: "Got it",
                    style: "white-space: pre-line"
                  });
                } else {
                  messageAPI.success("Your account has been updated");
                }

                _context.next = 29;
                break;

              case 23:
                _context.prev = 23;
                _context.t1 = _context["catch"](11);
                _context.next = 27;
                return handleError(_context.t1);

              case 27:
                errors.update = _context.sent;
                loaders.update = LoaderStateEnum.Failed;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7], [11, 23]]);
      }));

      return function update() {
        return _ref2.apply(this, arguments);
      };
    }();

    var validationIntent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _userStore$user4;

        var email;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loaders.validation = LoaderStateEnum.Loading;
                email = (_userStore$user4 = userStore.user) === null || _userStore$user4 === void 0 ? void 0 : _userStore$user4.email;
                _context2.prev = 2;
                _context2.next = 5;
                return userStore.triggerValidation({
                  email: email
                });

              case 5:
                setValidationLockDuration();
                loaders.validation = LoaderStateEnum.Loaded;
                messageAPI.success("An email has been sent to ".concat(email));
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                loaders.validation = LoaderStateEnum.Failed;
                _context2.t1 = messageAPI;
                _context2.next = 16;
                return handleError(_context2.t0);

              case 16:
                _context2.t2 = _context2.sent;

                _context2.t1.error.call(_context2.t1, _context2.t2);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }));

      return function validationIntent() {
        return _ref3.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_countdown = _resolveComponent("n-countdown");

      var _component_n_spin = _resolveComponent("n-spin");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_h2 = _resolveComponent("n-h2");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_form = _resolveComponent("n-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _unref(userStore).user ? (_openBlock(), _createBlock(_component_n_alert, {
        key: 0,
        type: _unref(userStore).user.emailConfirmed ? 'default' : 'warning',
        "show-icon": false
      }, {
        default: _withCtx(function () {
          return [_unref(userStore).user.emailConfirmed ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(" Hello " + _toDisplayString(_unref(userStore).user.userName) + ", here you can manage everything about your account. ", 1)], 64)) : (_openBlock(), _createBlock(_component_n_spin, {
            key: 1,
            show: _unref(loaders).validation === _unref(LoaderState).Loading
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(" Hello " + _toDisplayString(_unref(userStore).user.userName) + ", it seems like you didn't validate your email yet. Please do it in order to protect your account. ", 1), _createElementVNode("div", _hoisted_3, [!_unref(validationLocked) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_hoisted_4, _createVNode(_component_n_button, {
                size: "small",
                text: true,
                disabled: _unref(loaders).update === _unref(LoaderState).Loading || _unref(loaders).validation === _unref(LoaderState).Loading,
                onClick: validationIntent
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_text, {
                    type: "info",
                    underline: ""
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["disabled"]), _hoisted_6], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_hoisted_7, _createVNode(_component_n_countdown, {
                render: renderCountdown,
                duration: _unref(validationLock).duration,
                onFinish: _cache[0] || (_cache[0] = function ($event) {
                  return _unref(validationLock).duration = 0;
                })
              }, null, 8, ["duration"]), _hoisted_8], 64))])];
            }),
            _: 1
          }, 8, ["show"]))];
        }),
        _: 1
      }, 8, ["type"])) : _createCommentVNode("", true), _createVNode(_component_n_h2, null, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }), _createVNode(_component_n_form, {
        model: _unref(model),
        ref_key: "form",
        ref: form,
        rules: rules,
        autocomplete: "off"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_form_item, {
            path: "username"
          }, {
            label: _withCtx(function () {
              return [_hoisted_10, _hoisted_11];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).username,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(model).username = $event;
                }),
                disabled: true,
                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "email",
            label: "Email"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).email,
                "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
                  return _unref(model).email = $event;
                }),
                "input-props": {
                  autocomplete: 'off'
                },
                type: "email",
                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "password"
          }, {
            label: _withCtx(function () {
              return [_hoisted_12, _hoisted_13];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).password,
                "onUpdate:value": _cache[5] || (_cache[5] = function ($event) {
                  return _unref(model).password = $event;
                }),
                "input-props": {
                  autocomplete: 'new-password'
                },
                type: "password",
                "show-password-on": "click",
                onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createElementVNode("div", null, [_createVNode(_component_n_button, {
            type: "primary",
            disabled: !_unref(changed),
            loading: _unref(loaders).update === _unref(LoaderState).Loading,
            onClick: update
          }, {
            default: _withCtx(function () {
              return [_hoisted_14];
            }),
            _: 1
          }, 8, ["disabled", "loading"])]), _unref(loaders).update === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            type: "error",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).update), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["model"])]);
    };
  }
});